<template>
  <div v-if="isMobile">
    <div
      v-if="lpuAddressListFiltered.length > 1"
      class="text-subtitle-1 pl-2"
    >
      {{ t('Врач принимает в {countLpu} клиниках', options) }}:
    </div>
    <v-expansion-panels
      v-if="lpuAddressListFiltered.length"
      v-model="expandedPanels"
      :class="lpuAddressListFiltered.length > 1 ? 'custom-order-list' : undefined"
      accordion
      multiple
      tile
    >
      <DoctorPageLpuListLpu
        v-for="(lpuAddress, lpuAddressIndex) in lpuAddressListFiltered"
        :key="`${lpuAddress.id}-${lpuAddressIndex}-${filterType}`"
        :is-expanded="expandedPanels.includes(lpuAddressIndex)"
        :lpu-address="lpuAddress"
        :class="lpuAddressListFiltered.length > 1 ? 'custom-order-list__item' : undefined"
        @open-appointment-restrictions="openAppointmentRestrictions"
      />
    </v-expansion-panels>
    <template v-if="otherCountriesOfWork.length">
      <v-divider v-if="lpuAddressListFiltered.length" />
      <OtherCountriesOfDoctorWork />
    </template>

    <AppointmentRestrictions
      v-if="lpuAddressListFiltered.length"
      ref="appointmentRestrictionsRef"
    />
  </div>
  <v-card
    v-else
    flat
  >
    <DoctorPageLpuListLpu
      v-for="(lpuAddress, lpuAddressIndex) in lpuAddressListFiltered"
      :key="`${lpuAddress.id}-${lpuAddressIndex}-${filterType}`"
      :lpu-address="lpuAddress"
      @open-appointment-restrictions="openAppointmentRestrictions"
    />
    <OtherCountriesOfDoctorWork
      v-if="otherCountriesOfWork.length"
      class="mt-2"
    />
    <AppointmentRestrictions
      v-if="lpuAddressListFiltered.length"
      ref="appointmentRestrictionsRef"
    />
  </v-card>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { ref, nextTick, watch } from 'vue'
import { storeToRefs } from 'pinia'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useDoctorPageLpuListStore, useExternalDataStore } from 'www/vue_components/common/DoctorPageLpuList/stores'
import DoctorPageLpuListLpu from 'www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListLpu.vue'
import OtherCountriesOfDoctorWork from 'www/vue_components/common/DoctorPageLpuList/components/OtherCountriesOfDoctorWork.vue'
import AppointmentRestrictions from 'www/vue_components/common/AppointmentRestrictions/AppointmentRestrictions.vue'

const externalDataStore = useExternalDataStore()
const { isMobile, otherCountriesOfWork, doctor } = storeToRefs(externalDataStore)

const doctorPageLpuListStore = useDoctorPageLpuListStore()
const { filterType, expandedPanels, lpuAddressListFiltered } = storeToRefs(doctorPageLpuListStore)
const { updateSlots } = doctorPageLpuListStore

const appointmentRestrictionsRef = ref()

function openAppointmentRestrictions(lpu: typeof lpuAddressListFiltered['value'][0]['lpu']) {
  if (appointmentRestrictionsRef.value && doctor.value) {
    const needTranslate = true

    appointmentRestrictionsRef.value.open({
      doctor: { id: doctor.value.id },
      lpu: { id: lpu.id, name: transDynamic(lpu, `name,${window.LANGUAGE_DATA.currentLanguage.iso},${needTranslate}`) },
    })
  }
}

watch(filterType, async () => {
  /**
   * nextTick нужен, чтобы установились значения selectedItem, которые используются в useDoctorAppointmentCardStore
   */
  await nextTick()
  await nextTick()
  await updateSlots()
}, { immediate: true })

const { t, language } = I18NextVue
const options = {
  ns: language,
  countLpu: lpuAddressListFiltered.value.length,
}
</script>

<style lang="scss" scoped>
.custom-order-list {
  counter-reset: myCounter;

  &__item :deep(.lpu-order) {
    counter-increment: myCounter;

    &::before {
      content: counter(myCounter) '. ';
      margin-right: 8px;
    }
  }
}
</style>
